
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
} from 'element-ui';
import { ITrialForm } from '@/types/trial.d';
import app from '@/api/app';
import tEditor from '@/components/Editor/editor.vue';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    Button,
    Select,
    Option,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加试听课',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: ITrialForm;

  private types: { value: string; label: string; }[] = [];

  private knowledges: { value: string; label: string; }[] = [];

  private toolbarOptions: any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
  ];

  private placeholder: string = '请输入试听课描述'

  private editorTypeList: any = [
    {
      label: 'Scratch 3.0',
      value: 'U2FsdGVkX',
    },
    {
      label: 'Python',
      value: 'DnVaryx0CLJv',
    },
    {
      label: 'C++',
      value: '65S6k67PR',
    },
    {
      label: 'Microbit',
      value: 'A9UdYEdHP',
    },
    {
      label: 'Javascript',
      value: '184w1oQFh',
    },
    {
      label: 'HTML5',
      value: '18KIo5Rs8v1',
    },
    {
      label: 'Scratch 2.0',
      value: 'zKTYcHqz8P',
    },
  ]

  public $refs!: {
    form: Form,
    tEditor: tEditor;
  }

  mounted() {
    if (this.title.includes('编辑')) this.form = Object.assign({}, this.oldForm);
    this.getKnowledge();
    this.getCourseType();
    console.log(this.form.content);
  }

  /**
   * @author liangyongmou
   * @desc 获取知识点
   */
  getKnowledge() {
    app.getKnowledge().then((res: any) => {
      this.knowledges = res.map((em: any) => ({ label: em.label, value: em.value }));
    });
  }

  /**
   * @author liangyongmou
   * @desc 获取课程类型
   */
  getCourseType() {
    app.getCourseType().then((res: any) => {
      this.types = res.map((em: any) => ({ label: em.label, value: em.id }));
    });
  }

  /**
   * @author liangyongmou
   * @desc  富文本编辑器内容改变事件
   * @param { content } 富文本编辑器内容
   */
  contentChange(content: string) {
    this.form.content = content;
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    // this.$refs.tEditor.refresh();
    this.resetForm();
  }
}
